module.exports = __webpack_public_path__ + "static/media/YF23_0.c62c5e44.jpg";